module.exports = __webpack_public_path__ + "static/media/moving_forward_amber.f998b145.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/moving_forward_amber.svg
// module id = 1101
// module chunks = 2